import React from "react";
import { AgGridReact } from "ag-grid-react";
import { useMemo, useState, useCallback, useRef } from "react";

 

/**
 * This is a default grid component for all reports. Please do not change the settings unless customization is required.
 * @param {*} props 
 * @returns 
 */
export const ReportGrid = (props) => {
  const gridRef = useRef();
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.sizeColumnsToFit();
  }, []);
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      resizable: true,
      animateRows: true,
    }),
    []
  );

  return (
    <div className="ag-theme-balham" style={gridStyle}>
      <AgGridReact
        ref={gridRef}
        rowData={props.rowData}
        columnDefs={props.colDefs}
        defaultColDef={defaultColDef}
        onGridReady={props.onGridReady}
        alwaysShowHorizontalScroll={false}
        alwaysShowVerticalScroll={false}
        sideBar={"columns"}
        onFirstDataRendered={onFirstDataRendered}
        pagination={true}
      />
    </div>
  );
};